<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'

const baseStore = useBaseStore()

const toasterConfig = computed(() => {
  const isNativeApp = baseStore.platform === 'ios' || baseStore.platform === 'android'
  if (isNativeApp) {
    return {
      position: 'top-center' as const,
      ui: {
        viewport: '!top-[max(1rem,calc(var(--safe-top)+0.25rem))]',
      },
    }
  }
  return { position: 'bottom-right' as const }
})

useHead({
  title: 'Home',
  meta: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover',
    },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
  ],
})
</script>

<template>
  <UApp :locale="fr" :toaster="toasterConfig">
    <NuxtLoadingIndicator color="#F37A4E" />

    <NuxtLayout>
      <NuxtPage :keepalive="{ include: ['ShoppingListPage', 'RecipeBoxPage'] }" />
    </NuxtLayout>
  </UApp>
</template>

<style>
@font-face {
  font-family: 'Albra Bold';
  src: url('https://glouton.b-cdn.net/fonts/Albra-Bold.woff2') format('woff2');
}

html.dark {
  color-scheme: dark;
}
</style>
